export default __webpack_public_path__ + "static/media/Tiger's Arm-straps of Pierced Flesh.0688c3f1.jpg";